import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let SweepRulesOption: LazyOption = createLazyOption(
    {
        key: 'sweepRules',
        titleStringKey: 'optionTitle_sweepRules',
        hideTitleInFullOptions: true,
        searchTermsStringKey: 'optionTitle_sweepRules',
        isHidden: () => IsShadowMailboxUser(),
    },
    lazyFullModule,
    m => m.default
);
export default SweepRulesOption;
